<template>
  <RedesignRoundButton
    :class="{ 'bg-thm-light': selected.length }"
    v-bind="$attrs"
    @click="open"
  >
    <WebccIcon name="searchpage/filter" class="h-3.5 w-3.5 mr-2" />
    <span class="text-sm">
      {{ $t(`${trPrefixCommon}filters`) }}
      <span v-if="selected.length" class="ml-0.5">({{ selected.length }})</span>
    </span>
  </RedesignRoundButton>

  <RedesignWebccDialog full-screen="sm" :open="isOpen" @close="discard">
    <template #title>
      <h3>{{ $t(`${trPrefixCommon}filters`) }}</h3>
    </template>

    <template #default>
      <RedesignFilter v-model="state" class="w-full" />
    </template>

    <template #footer>
      <div class="flex w-full flex-row items-center justify-between gap-4">
        <button
          class="text-left underline font-semibold flex gap-1 items-center"
          @click.stop="removeBatch()"
        >
          {{ $t(`${trPrefixCommon}removeAllFilters`) }}
        </button>

        <WebccButton
          variant="theme"
          class="!py-2.5 !px-3 !text-base whitespace-normal"
          @click="view"
        >
          {{ $t(`${trPrefixCommon}viewPlaces`, total) }}
        </WebccButton>
      </div>
    </template>
  </RedesignWebccDialog>
</template>

<script setup lang="ts">
const trPrefixCommon = 'www.common.'

const model = defineModel<SearchState>({ required: true })

const emit = defineEmits<{
  (e: 'on-opened'): void
}>()

const { state, apply, restore } = useIntermediateState(model)
const { selected, removeBatch } = useFilters(state)
const searchResults = useSearchResults(toReactive(state))

const [isOpen, toggle] = useToggle()

const total = computed(() => searchResults.total)

function open() {
  toggle(true)
  emit('on-opened')
}

function view() {
  apply()
  toggle(false)
}

function discard() {
  restore()
  toggle(false)
}
</script>
